import {logRejection} from "services-comun/modules/decorators/metodo";

import dominio from "../../portal/ed";
import {FrontendRequest, RequestResponse} from "services-comun/modules/net/request-frontend";

export class TemplatesWebFrontendRequest extends FrontendRequest {
    /* STATIC */
    private static SERVICIO: string = dominio.get(dominio.SERVICES);

    @logRejection(true)
    public static async perfilUsuario(email: string): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/login/pagina/mi-perfil/?email=${email}`);
    }

    @logRejection(true)
    public static async equiposUsuario(email: string): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/login/pagina/mis-equipos/?email=${email}`);
    }

    @logRejection(true)
    public static async loginPopup(): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/login/autenticacion/`);
    }

    @logRejection(true)
    public static async loginSubmenu(email: string): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/login/submenu/?email=${email}`);
    }

    @logRejection(true)
    public static async loginPopUpSugerencia(): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/login/sugerencia/`);
    }

    @logRejection(true)
    public static async loginPopUpValidacion(): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/login/validacion/`);
    }

    @logRejection(true)
    public static async loginPopUpRestablecerPassword(): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/login/restablecer/`);
    }

    @logRejection(true)
    public static async loginPopUpRestablecerPasswordInfo(): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/login/restablecer/info/`);
    }

    @logRejection(true)
    public static async noticiaDesarrollo(id: number, device: string): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/noticia/desarrollo/?id=${id}&device=${device}`);
    }

    @logRejection(true)
    public static async popupPWA(): Promise<RequestResponse<string>> {
        return this.getString(`${this.SERVICIO}/web/templates/pwa/popup/`);
    }

    /* INSTANCE */
}
